// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"576":"892db55c","676":"81154ead"}[chunkId] + ".chunk.css";
};